<template>
  <div id="footer">
    <div class="content5">
      <div class="con">
        <div class="contactInfo">
          <div class="title">{{$t("contactInfo.title")}}</div>
          <div class="conText">
            <div>{{$t("contactInfo.email")}}</div>
            <div>{{$t("contactInfo.cntel")}}</div>
            <div>{{$t("contactInfo.entel")}}</div>
            <div class="add">{{$t("contactInfo.address")}}</div>
          </div>
        </div>
        <div class="menuInfo">
          <div class="title">{{$t("menu.Sitemap")}}</div>
          <div class="conText link">
            <router-link :to="{path:'/Home'}">
              <div>{{$t("menu.Home")}}</div>
            </router-link>
            <!-- <router-link :to="{path:'/Products'}">
              <div>{{$t("menu.Products")}}</div>
            </router-link> -->
            <!-- <router-link :to="{path:'/Features'}"> -->
              <div>{{$t("menu.Features")}}</div>
            <!-- </router-link> -->
            <router-link :to="{path:'/Faq'}">
              <div>{{$t("menu.FAQ")}}</div>
            </router-link>
            <router-link :to="{path:'/Contact'}">
              <div>{{$t("menu.Contact")}}</div>
            </router-link>
            <router-link :to="{path:'/About'}">
              <div>{{$t("menu.About")}}</div>
            </router-link>
          </div>
        </div>
        <div class="weChatInfo">
          <div class="title">{{$t("contactInfo.wechat")}}</div>
          <div class="conText">
            <div><img src="/static/images/common/qrcode.png" alt=""></div>
            <div>{{$t("contactInfo.wechatMsg")}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="con">
        <span>Copyright © Lettuce. Trademarks to belong to their respective owners. All rights reserved.</span>
        <span>Terms of Service    Privacy Policy</span>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {

  data() {
    return {

    };
  },
  //定义这个sweiper对象
  computed: {},
  mounted() {
  },
  methods: {


  }
};
</script>
<style scoped lang="less" type="text/less">
#footer{
  .content5{
    padding: 60px 0;
    background: #3B3D40;
    .con{
      width: 60%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .contactInfo,.menuInfo,.weChatInfo{
        text-align: left;
        .title{
          font-size: 20px;
          color: #fff;
          font-weight: bold;
        }
        .conText{
          font-size: 14px;
          color: #fff;
          padding: 15px 0;
          line-height: 34px;
          .add{
            width: 80%;
            line-height: 24px;
          }
          &.link{
            div{
              cursor: pointer;
              color: #fff;
            }
          }
        }
      }
      .menuInfo{
        width: 30%;
      }
    }
  }
  .footer{
    background: #505254;
    padding: 20px;
    .con{
      width: 60%;
      text-align: center;
      margin: 0 auto;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue